<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large overflow-x-auto"
  >
    <template v-slot:header="{ ok, cancel }">
      <v-card-title class="screen-title">VNコネクト情報</v-card-title>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click="isChanged ? ok() : cancel()"
      >
        ×
      </button>
    </template>
    <template v-if="isLoaded" v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="d-flex flex-row ga-2 justify-end">
                <v-btn
                  v-if="isEditDelete"
                  v-permission.config
                  color="primary"
                  @click="modifyVnConnect"
                  >変更</v-btn
                >
                <v-btn
                  v-if="isEditDelete"
                  v-permission.config
                  color="primary"
                  @click="delVnConnect"
                  >削除</v-btn
                >
              </v-col>
            </v-row>

            <!-- 基本情報 -->
            <v-row>
              <v-col cols="12">
                <h3>基本情報</h3>
              </v-col>
            </v-row>
            <div class="ml-2">
              <v-row>
                <v-col cols="4">
                  <app-label-group label="VNコネクト番号" :value="wnumber" />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="VNコネクト名"
                    :value="vNConnect.vnConnectName"
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="回線番号"
                    :value="$filter.emptyTo(vNConnect.enumber, '-')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <app-label-group
                    label="VLAN"
                    :value="
                      vNConnect.vlanIdType === 'SPECIFIED'
                        ? vNConnect.vlanId
                        : $filter.enumTo(vNConnect.vlanIdType, 'vlanIdType')
                    "
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group label="品目">
                    <template #value>
                      <div class="ml-3">
                        <template v-if="vNConnect.bandwidthType === 'BURST'">
                          <template v-if="lineBandwidth">
                            バースト
                            <template
                              v-if="lineBandwidth.bandwidthType === 'BURST10'"
                              >(バースト10)</template
                            >
                            <template
                              v-else-if="
                                lineBandwidth.bandwidthType === 'BURST100'
                              "
                              >(バースト100)</template
                            >
                          </template>
                          <template v-else>バースト</template>
                        </template>
                        <template v-else>
                          {{
                            $filter.enumTo(
                              vNConnect.bandwidthType,
                              "vnConBandwidthType"
                            )
                          }}
                          <template v-if="vNConnect.bandwidth">
                            (
                            {{ vNConnect.bandwidth.value }}
                            {{
                              $filter.enumTo(
                                vNConnect.bandwidth.unit,
                                "bandwidth_unit"
                              )
                            }}
                            )
                          </template>
                        </template>
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="QoS"
                    :value="
                      vNConnect.qos
                        ? $filter.enumTo(vNConnect.qos.isQoS, 'on_off')
                        : ' - '
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <app-label-group
                    label="ペア回線"
                    :value="$filter.emptyTo(vNConnect.pairLine, '-')"
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="IF状態"
                    :value="
                      $filter.enumTo(vNConnect.ifStatus, 'cloudVn_ifStatus')
                    "
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="有効/無効"
                    :value="
                      $filter.enumTo(vNConnect.isVnConnectStatus, 'enable')
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <app-label-group
                    label="備考"
                    :value="$filter.emptyTo(vNConnect.description, '-')"
                  />
                </v-col>
              </v-row>
            </div>

            <!-- ルーティング種別 -->
            <div v-if="vNConnect.vnType === 'L3' && vNConnect.l3">
              <v-row>
                <v-col cols="12" class="mt-2">
                  <h3>ルーティング情報</h3>
                </v-col>
              </v-row>
              <div class="ml-2">
                <v-row>
                  <v-col cols="3">
                    <app-label-group
                      label="WANアドレス"
                      :value="vNConnect.l3.wanAddress"
                    />
                  </v-col>
                  <v-col cols="5">
                    <app-label-group
                      label="ルーティング種別"
                      :value="vNConnect.l3.bgp4 !== null ? 'BGP4' : 'Static'"
                    />
                  </v-col>

                  <!-- ルーティング種別BGP4 -->
                  <template v-if="vNConnect.l3.bgp4">
                    <v-col cols="4">
                      <app-label-group
                        label="AS番号"
                        :value="vNConnect.l3.bgp4.asNumber"
                      />
                    </v-col>
                    <v-col cols="3">
                      <app-label-group
                        label="ピアIPアドレス"
                        :value="vNConnect.l3.bgp4.peerIpAddress"
                      />
                    </v-col>
                    <v-col cols="5">
                      <app-label-group
                        label="MD5キー"
                        :value="$filter.emptyTo(vNConnect.l3.bgp4.md5Key, '-')"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-label-group
                        label="Maximum Prefix"
                        :value="vNConnect.l3.bgp4.maximumPrefix"
                      />
                    </v-col>
                    <v-col cols="3">
                      <app-label-group
                        label="Local Preference"
                        :value="
                          $filter.enumTo(
                            vNConnect.l3.bgp4.localPreference,
                            'localPreference'
                          )
                        "
                      />
                    </v-col>
                    <v-col cols="5">
                      <app-label-group
                        label="MED"
                        :value="$filter.enumTo(vNConnect.l3.bgp4.med, 'med')"
                      />
                    </v-col>
                  </template>
                </v-row>
              </div>
            </div>

            <!-- 接続先VPN/VN -->
            <v-row>
              <v-col cols="12" class="mt-2">
                <h3>接続先VPN/VN</h3>
              </v-col>
            </v-row>
            <div class="ml-2">
              <v-row>
                <v-col cols="4">
                  <app-label-group
                    label="VPN/VNコード"
                    :value="vNConnect.vpnVnCode"
                  />
                </v-col>
                <v-col cols="4">
                  <div class="ml-2">
                    <app-label-group
                      label="仮想ネットワーク(VN)名"
                      :value="$filter.emptyTo(vNConnect.vnName, '-')"
                    />
                  </div>
                </v-col>
                <v-col cols="4">
                  <app-label-group label="L2/L3" :value="vNConnect.vnType" />
                </v-col>
              </v-row>
            </div>

            <!-- L2/L3(BGP4)の場合、カスタム経路集約情報 -->
            <div
              v-if="
                vNConnect.vnType === 'L3' &&
                vNConnect.l3 &&
                vNConnect.l3.bgp4 !== null
              "
            >
              <v-row>
                <v-col cols="12" class="mt-2">
                  <h3>カスタム経路集約情報</h3>
                </v-col>
              </v-row>
              <div class="ml-2">
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="経路集約"
                      :value="vNConnect.l3.bgp4.routeAggregation"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="vNConnect.l3.bgp4.routeAggregation !== 'OFF'">
                  <v-col cols="12">
                    <app-label-group label="経路集約アドレス">
                      <template #value>
                        <template
                          v-if="vNConnect.l3.bgp4.routeAggregation === 'CUSTOM'"
                        >
                          <div class="d-flex flex-wrap">
                            <span
                              class="ml-3"
                              v-for="(
                                e, index
                              ) in sortedRouteAggregationAddressList"
                              :key="index"
                            >
                              {{ e }}
                            </span>
                          </div>
                        </template>
                        <template
                          v-else-if="
                            vNConnect.l3.bgp4.routeAggregation === 'ON'
                          "
                        >
                          <span class="ml-3">0.0.0.0/0</span>
                        </template>
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
              </div>
            </div>

            <!-- L3(Static)の場合、経路設定 -->
            <div
              v-if="
                vNConnect.vnType === 'L3' &&
                vNConnect.l3 &&
                vNConnect.l3.static !== null
              "
            >
              <v-row>
                <v-col cols="12" class="mt-2">
                  <h3>経路設定</h3>
                </v-col>
              </v-row>
              <div class="ml-2">
                <v-row>
                  <v-col cols="6">
                    <app-label-group label="LANアドレス">
                      <template #value>
                        <div class="pl-4">
                          <template
                            v-if="sortedStaticLanAddressList.length !== 0"
                          >
                            <div
                              v-for="(e, index) in sortedStaticLanAddressList"
                              :key="index"
                            >
                              {{ $filter.emptyTo(e.lanAddress, "-") }}
                            </div>
                          </template>
                          <template v-else>-</template>
                        </div>
                      </template>
                    </app-label-group>
                  </v-col>
                  <v-col cols="6">
                    <app-label-group label="ネクストホップアドレス">
                      <template #value>
                        <div class="pl-4">
                          <template
                            v-if="sortedStaticLanAddressList.length !== 0"
                          >
                            <div
                              v-for="(e, index) in sortedStaticLanAddressList"
                              :key="index"
                            >
                              {{ $filter.emptyTo(e.nextHopAddress, "-") }}
                            </div>
                          </template>
                          <template v-else>-</template>
                        </div>
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
              </div>
            </div>

            <!-- DHCPリレー : L3のみ表示する -->
            <div v-if="vNConnect.vnType === 'L3' && vNConnect.l3">
              <v-row>
                <v-col cols="12" class="mt-2">
                  <h3>DHCPリレー</h3>
                </v-col>
              </v-row>
              <div class="ml-2">
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="DHCPリレー"
                      :value="vNConnect.l3.dhcpRelay ? 'ON' : 'OFF'"
                    />
                  </v-col>
                </v-row>
                <template v-if="vNConnect.l3.dhcpRelay">
                  <v-row>
                    <v-col v-if="vNConnect.l3.dhcpRelay" cols="6">
                      <app-label-group
                        label="プライマリサーバ"
                        :value="vNConnect.l3.dhcpRelay.primaryAddress"
                      />
                    </v-col>
                    <v-col cols="6">
                      <app-label-group
                        label="セカンダリサーバ"
                        :value="
                          $filter.emptyTo(
                            vNConnect.l3.dhcpRelay.secondaryAddress,
                            '-'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </template>
              </div>
            </div>

            <!-- VLAN制御 : L2のみ表示する -->
            <div v-if="vNConnect.vnType === 'L2'">
              <v-row>
                <v-col cols="12" class="mt-2">
                  <h3>VLAN制御</h3>
                </v-col>
              </v-row>
              <div class="ml-2">
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="VLAN制御"
                      :value="
                        $filter.enumTo(vNConnect.l2!.isVlanControl, 'on_off')
                      "
                    />
                  </v-col>
                </v-row>
              </div>
            </div>

            <v-row class="mt-6">
              <v-col>
                <v-tabs
                  v-model="tabValue"
                  @update:modelValue="alertClear"
                  hide-slider
                  class="border-s-sm border-t-sm border-e-sm"
                >
                  <v-tab text="運用コマンド" value="operationCommand" />
                  <v-tab
                    text="トラフィック"
                    value="traffic"
                    v-if="!isFutureDayContract && contractSummary.isTrafficInfo"
                  />
                  <v-tab
                    text="設定上限値"
                    value="upperLimit"
                    v-if="!vNConnect.isAssociate"
                  />
                  <v-tab
                    text="QoS設定情報"
                    value="qos"
                    v-if="vNConnect.qos && vNConnect.qos.isQoS"
                  />
                </v-tabs>
                <v-tabs-window
                  v-model="tabValue"
                  class="border-s-sm border-b-sm border-e-sm"
                >
                  <v-tabs-window-item value="operationCommand">
                    <operation-command
                      ref="operationCommand"
                      lineCategory="VN"
                      :wnumber="wnumber"
                      :vnConnectDetail="vNConnect"
                      :show-if-status="!vNConnect.isAssociate"
                      :ifStatus="vNConnect.ifStatus"
                      :key-id="vNConnect.vnConnectKeyId"
                      @executed="executed"
                    ></operation-command>
                  </v-tabs-window-item>
                  <v-tabs-window-item value="traffic">
                    <traffic
                      line-type="VN"
                      :line="{
                        wnumberMainAct: wnumber,
                        vpnVnCode: vNConnect.vpnVnCode,
                      }"
                    />
                  </v-tabs-window-item>
                  <v-tabs-window-item value="upperLimit">
                    <upper-limit upperLimitManageUnit="VN" :wnumber="wnumber" />
                  </v-tabs-window-item>
                  <v-tabs-window-item value="qos">
                    <qos-setting
                      :vpnVnCode="vNConnect.vpnVnCode"
                      :band-control-pattern="
                        vNConnect.qos?.qosBandControlPattern
                      "
                    ></qos-setting>
                  </v-tabs-window-item>
                </v-tabs-window>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="isChanged ? ok() : cancel()"
              variant="outlined"
              color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { VNConnectDetail } from "@/apis/VNConnectApi";
import type {
  AccessLineGetEntity,
  BandwidthListGetEntity,
} from "@/apis/AccessLineApi";
import { mapState } from "vuex";
import type { ContractInfo } from "@/apis/ContractApi";
import { VueFinalModal } from "vue-final-modal";
import VNConnectDeleteConfirm from "@/modals/vnConnect/VNConnectDeleteConfirm.vue";
import Traffic from "@/components/operation-tool/Traffic.vue";
import OperationCommand from "@/components/operation-tool/OperationCommand.vue";
import UpperLimit from "@/components/operation-tool/UpperLimit.vue";
import QosSetting from "@/components/operation-tool/QosSetting.vue";
import VNConnectEdit from "@/modals/vnConnect/VNConnectEdit.vue";
import sortCompare from "@/services/SortService";

export default defineComponent({
  name: "VNConnectReference",
  components: { OperationCommand, Traffic, UpperLimit, QosSetting },
  props: {
    /** W番号 */
    wnumber: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      tabValue: "operationCommand" as
        | "operationCommand"
        | "traffic"
        | "upperLimit"
        | "qos",
      vNConnect: {} as VNConnectDetail,
      accessLine: {} as AccessLineGetEntity,
      isLoaded: false,
      isChanged: false,
    };
  },
  computed: {
    ...mapState("user", {
      contractInfo: "contractInfo",
      contractSummary: "contractSummary",
    }),
    /** true: 変更・削除可能, false: 不可 （PFGW(インターネット)、V連携の場合） */
    isEditDelete(): boolean {
      return this.vNConnect.enumber !== null && !this.vNConnect.isAssociate;
    },
    /** 回線契約状況、回線種別によっては存在しないのでその場合はundefined */
    lineBandwidth(): BandwidthListGetEntity | undefined {
      return this.accessLine.bandwidthList.find(
        (e) =>
          e.enumberAct === this.vNConnect.enumber ||
          e.enumberSby === this.vNConnect.enumber
      );
    },
    /** 開始日が未来日の場合,true*/
    isFutureDayContract(): boolean {
      return !this.contractInfo.contractList.find(
        (e: ContractInfo["contractList"][0]) =>
          e.enumber === this.vNConnect.enumber
      );
    },
    /**
     * 経路集約アドレスリストをIPアドレスの数値順で昇順ソートして返す
     * @returns ソート済みの経路集約アドレスリスト
     */
    sortedRouteAggregationAddressList(): string[] {
      const list = this.vNConnect?.l3?.bgp4?.routeAggregationAddressList ?? [];
      return list.sortIpAddress();
    },
    /**
     * StaticルートのLANアドレスをIPアドレスの数値順で昇順ソートして返す
     * @returns ソート済みのstaticルート配列
     */
    sortedStaticLanAddressList(): {
      lanAddress: string;
      nextHopAddress: string;
    }[] {
      const list = this.vNConnect?.l3?.static ?? [];
      return [...list].sort((a, b) =>
        sortCompare(a, b, [["lanAddress", "asc"]])
      );
    },
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      this.vNConnect = await this.$api.vNConnect.getVNConnectDetail(
        this.wnumber
      );
      this.accessLine = await this.$api.accessLine.getAll();
    },

    /** 変更 */
    async modifyVnConnect() {
      await this.alertClear();
      await this.$modal.show(VNConnectEdit, {
        wnumber: this.wnumber,
        connect: this.vNConnect,
        keyId: this.vNConnect.vnConnectKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** 削除 */
    async delVnConnect() {
      await this.alertClear();
      await this.$modal.show(VNConnectDeleteConfirm, {
        wnumber: this.wnumber,
        connect: this.vNConnect,
        lineBandwidth: this.lineBandwidth,
      });
      await this.$api.vNConnect.deleteVNConnect(this.wnumber, {
        vnConnectKeyId: this.vNConnect.vnConnectKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /**
     * コマンド実行後の処理
     * IF設定反映の場合、一覧画面へ戻る
     * @param eventType 実行されたコマンドの種類
     */
    async executed(eventType: string) {
      if (eventType === "IF_STATE") {
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      } else {
        this.isChanged = true;
        await this.load();
      }
    },

    /** エラーメッセージを初期化する */
    async alertClear() {
      await (
        this.$refs.operationCommand as InstanceType<typeof OperationCommand>
      ).alertClear();
    },
  },
});
</script>
